<template>
	<div class="datepicker" :class="{'datepicker-range':range,'datepicker__clearable':clearable&&text&&!disabled}">
		<input type="text" readonly :value="text" :class="[show ? 'focus' : '', inputClass]" :disabled="disabled" :placeholder="placeholder" :name="name"/>
		<a class="datepicker-close" @click.stop="cls"></a>
			<div class="datepicker-popup" :class="popupClass" tabindex="-1" v-if="show">
				<template v-if="range">
					<vue-datepicker-local-calendar v-model="dates[0]" :left="true"></vue-datepicker-local-calendar>
					<vue-datepicker-local-calendar v-model="dates[1]" :right="true"></vue-datepicker-local-calendar>
				</template>
				<template v-else>
					<vue-datepicker-local-calendar v-model="dates[0]" :startYear="startYear" :endYear="endYear"></vue-datepicker-local-calendar>
				</template>
			</div>
	</div>
</template>

<script>
import VueDatepickerLocalCalendar from './VueDatepickerLocalCalendar.vue'
import settings from '@/services/settings'
export default {
  name: 'VueDatepickerLocal',
  components: { VueDatepickerLocalCalendar },
  props: {
    name: [String],
    inputClass: [String],
    popupClass: [String],
    value: [Date, Array, String],
    disabled: [Boolean],
    rangeSeparator: {
      type: String,
      default: '~'
    },
    startYear: null,
    endYear: null,
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: [String],
    disabledDate: {
      type: Function,
      default: () => {
        return false
      }
    },
    format: {
      type: String,
      default: settings.dateFormat
    },
    local: {
      type: Object,
      default () {
        return {
          dow: 1, // Monday is the first day of the week
          hourTip: 'hour', // tip of select hour
          minuteTip: 'minute', // tip of select minute
          secondTip: 'second', // tip of select second
          yearSuffix: '', // format of head
          monthsHead: this.$t('dateTime.months').split('_'), // months of head
          months: this.$t('dateTime.months').split('_'), // months of panel
          weeks: this.$t('dateTime.days').split('_') // weeks
        }
      }
    }
  },
  data () {
    return {
      show: false,
      dates: this.vi(this.value)
    }
  },
  computed: {
    range () {
      return this.dates.length === 2
    },
    text () {
      const val = this.value
      const txt = this.dates.map(date => this.tf(date)).join(` ${this.rangeSeparator} `)
      if (Array.isArray(val)) {
        return val.length > 1 ? txt : ''
      } else {
        return val ? txt : ''
      }
    }
  },
  watch: {
    value (val) {
      this.dates = this.vi(this.value)
    }
  },
  methods: {
    cls () {
      this.$emit('input', this.range ? [] : '')
    },
    vi (val) {
      if (Array.isArray(val)) {
        return val.length > 1 ? val.map(item => new Date(item)) : [new Date(), new Date()]
      } else {
        return val ? new Array(new Date(val)) : [new Date()]
      }
    },
    ok () {
      const $this = this
      $this.$emit('input', Array.isArray($this.value) ? $this.dates : $this.dates[0])
      setTimeout(() => {
        $this.show = $this.range
      })
    },
    tf (time, format) {
      const year = time.getFullYear()
      const month = time.getMonth()
      const day = time.getDate()
      const hours24 = time.getHours()
      const hours = hours24 % 12 === 0 ? 12 : hours24 % 12
      const minutes = time.getMinutes()
      const seconds = time.getSeconds()
      const milliseconds = time.getMilliseconds()
      const dd = t => ('0' + t).slice(-2)
      const map = {
        YYYY: year,
        MM: dd(month + 1),
        MMM: this.local.months[month],
        MMMM: this.local.monthsHead[month],
        M: month + 1,
        DD: dd(day),
        D: day,
        HH: dd(hours24),
        H: hours24,
        hh: dd(hours),
        h: hours,
        mm: dd(minutes),
        m: minutes,
        ss: dd(seconds),
        s: seconds,
        S: milliseconds
      }
      return (format || this.format).replace(/Y+|M+|D+|H+|h+|m+|s+|S+/g, str => map[str])
    },
    dc (e) {
      this.show = this.$el.contains(e.target) && !this.disabled
    }
  },
  mounted () {
    document.addEventListener('click', this.dc)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.dc)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/widgets/datepicker/VueDatepickerLocal.vue